export default "__VITE_ASSET__CP7QVj_S__"